import { render, staticRenderFns } from "./NewAttachment.vue?vue&type=template&id=2681f2f5&scoped=true"
import script from "./NewAttachment.vue?vue&type=script&lang=js"
export * from "./NewAttachment.vue?vue&type=script&lang=js"
import style0 from "./NewAttachment.vue?vue&type=style&index=0&id=2681f2f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2681f2f5",
  null
  
)

export default component.exports